import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import moment from 'moment';

import Following from './following';
import Medical from './medical';


var Config = require('../../../config');

class GeneralModal extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		
		this.getSeguimiento = this.getSeguimiento.bind(this);
		this.removePhone = this.removePhone.bind(this);
		this.addPhone = this.addPhone.bind(this);

		this.handleChange = this.handleChange.bind(this);
		this.onSave = this.onSave.bind(this);

		this.state = {
		    show: false,
		    screen: "",
		    data:{},
		    donation_id:"",
		    medical_id:"",
		    follow:{
		    	phone_number:"",
		    	phones:[],
		    	phone_type:"",
		    	phoneTypes:[],
		    	status:"",
		    	status_list:[
		    		{value:'no localizado', name:'No Localizado'},
					{value:'localizado', name:'Localizado'},
					{value:'se presentara', name:'Se Presentará'},
		    	],
		    	comment:"",
		    	agenda:false,
		    	date:""
		    },

		    medical:{
		    	comment:"",
		    	name:""
		    },

		    personal:{
		    	comment:"",
		    	name:""
		    }
		};
	}

	componentDidMount() {
		this.props.onRef(this);

		
	}
	componentDidUpdate(){
	}
	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false, 
			screen: "",
		    data:{},
		    donation_id:"",
		    follow:{
		    	phone_number:"",
		    	phones:[],
		    	status:"",
		    	status_list:[
		    		{value:'no localizado', name:'No Localizado'},
					{value:'localizado', name:'Localizado'},
					{value:'se presentara', name:'Se Presentará'},
		    	],
		    	comment:"",
		    	agenda:false,
		    	date:"",
		    	comments:[]
		    },

		    medical:{
		    	comment:"",
		    	name:""
		    }
		});
	}

	getSeguimiento(obj){
		this.props.waiting.handleShow('Cargando');

		fetch(Config.default.apiGateway.URL+'epidemiological_monitoring/by_donation?id='+obj.id+'&process='+obj.process,{
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();

			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({data:response, show:true});
				
				if(obj.process === 'CALL'){
					if(response.monitoring !== null){
						this.setState({
							follow:{
								...this.state.follow,
								//status: response.process.status !== null ? response.process.status.toLowerCase() : "",
								agenda:response.monitoring.reminder !== null ? true : false,
								date:response.monitoring.reminder !== null ?
									moment(response.monitoring.reminder).format('YYYY-MM-DD') : "",
							}
						});
					}

					if(response.process !== null){
						this.setState({
							follow:{
								...this.state.follow,
								comments:response.process,
							}
						})
					}

					this.setState({
						follow:{
							...this.state.follow,
							phones:response.phones
						}
					});	
				}else if(obj.process === 'INTERVIEW'){
					if(response.process !== null){
						this.setState({
							medical:{
								...this.state.medical,
								comment:response.process.comments
							}
						});
					}
				}else{
					if(response.process !== null){
						this.setState({
							medical:{
								...this.state.medical,
								comment:response.process.comments
							}
						});
					}
				}
				

				
			}
		})
	}

	handleShow(screen, obj={}) {
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		fetch(Config.default.apiGateway.URL+'lookups?type=PHONE_TYPE&notrender=0',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
	    })
	    .then(response => response.json())
	    .then(response => {
	    	this.setState({
				follow:{
					...this.state.follow,
					phoneTypes: response
				}
			});
	    })

		this.setState({
			medical:{
				...this.state.medical,
				name:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names,
			},
			personal:{
				...this.state.personal,
				name:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names,
			},
			medical_id:medical.id,
			screen:screen, 
			donation_id:obj.id
		});

		this.getSeguimiento(obj);
		
	}

	handleChange(obj, item, value){
		this.setState({
			[obj]: {
	          ...this.state[obj],
	          [item]: value
		    }
		});
	}

	onSave(){
		if(this.isValidForm()){
			var apiUrl = 'epidemiological_monitoring';
			var method = 'POST';

			var obj = {};
				
	        if(this.state.screen === 'seguimiento'){
	        	
	        	obj = {
	        		person_id: this.state.data.person_id, //Id de la persona (donador)
				   	monitoring: {
		        		donation_id: this.state.donation_id,
		        		reminder : this.state.follow.date,
		        		monitoring_traceability:[{
		        			process:'CALL',
		        			medical_staff_id: this.state.medical_id,
		        			comments: this.state.follow.comment,
		        			status: this.state.follow.status,
		        		}]
				   	},
				   	phones: this.state.follow.phones
				};

				if(this.state.data.process !== null){
					this.state.data.process.map((p)=>{
						obj.monitoring.monitoring_traceability.push({
							process:p.process,
							medical_staff_id: p.medical_staff_id,
							comments: p.comments,
							status: p.status,
							id: p.id
						});
					});
					
					/*obj.monitoring.monitoring_traceability = [{
	        			id:this.state.data.process.id,
	        			epidemiological_monitoring_id:this.state.data.process.epidemiological_monitoring_id,
	        			process:this.state.data.process.process,
	        			medical_staff_id: this.state.medical_id,
	        			comments: this.state.follow.comment
	        		}]*/
				}

	        	if(this.state.data.monitoring !== null){
		        	obj.monitoring.id = this.state.data.monitoring.id;
		        	apiUrl = 'epidemiological_monitoring/'+obj.monitoring.id;
	        		method = 'PUT';
		        }
	        }else if(this.state.screen === 'medical'){
	        	obj = {
        			process:'INTERVIEW',
        			medical_staff_id: this.state.medical_id,
        			comments: this.state.medical.comment
        		};

	        	if(this.state.data.process !== null){
					obj = {
						id:this.state.data.process.id,
		        		epidemiological_monitoring_id: this.state.data.process.epidemiological_monitoring_id,
		        		process: this.state.data.process.process,
		        		medical_staff_id:this.state.medical_id,
		        		comments:this.state.medical.comment
		        	};
				}

	        	if(this.state.data.monitoring !== null){
		        	obj.epidemiological_monitoring_id = this.state.data.monitoring.id;
		        	apiUrl = 'epidemiological_monitoring/by_process/'+obj.epidemiological_monitoring_id;
	        		method = 'PUT';
		        }
	        }else{
	        	obj = {
	        		process:'END',
	        		medical_staff_id:this.state.medical_id,
	        		comments:this.state.personal.comment
	        	};

	        	if(this.state.data.process.length !== 0){
					obj = {
						id:this.state.data.process[0].id,
	        			epidemiological_monitoring_id: this.state.data.process[0].epidemiological_monitoring_id,
	        			process: this.state.data.process[0].process,
	        			medical_staff_id: this.state.medical_id,
	        			comments: this.state.personal.comment
	        		}
				}

	        	if(this.state.data.monitoring !== null){
		        	obj.epidemiological_monitoring_id = this.state.data.monitoring.id;
		        	apiUrl = 'epidemiological_monitoring/by_process/'+obj.epidemiological_monitoring_id;
	        		method = 'PUT';
		        }
	        }


	        /*obj.phones = this.state.follow.phones;
	        obj.monitoring.donation_id = this.state.donation_id;
	        obj.monitoring.call_status = this.state.follow.status; //Estatus combo
	        obj.monitoring.call_comments = this.state.follow.comment;
	        obj.monitoring.reminder = this.state.follow.date; //Fecha del recordatorio
		    
			obj.monitoring.interviewing_doctor = this.state.screen === 'seguimiento' && this.state.medical_id !== null ? null : this.state.medical_id; //Id del MEDICAL STAFF que está logueado
		    obj.monitoring.interview_comments = this.state.screen === 'seguimiento' && this.state.medical.comment ? null : this.state.medical.comment;

			    
	        obj.monitoring.doctor_ending = this.state.screen === 'seguimiento' && this.state.medical_id !== null ? null : this.state.medical_id; //Id del MEDICAL STAFF que está logueado
	        obj.monitoring.end_comments = this.state.screen === 'seguimiento' ? null : this.state.personal.comment;
			  */ 
			this.props.waiting.handleShow('Guardando...');
			fetch(Config.default.apiGateway.URL+apiUrl,{
				method: method,
				body:JSON.stringify(obj),
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then((res)=> {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then((response)=>{
				if(response !== undefined){
					this.props.getList('all');

					setTimeout(()=>{
						this.handleClose();
					}, 500);
					
				}
			}) 

			console.log(obj)

		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	isValidForm() {
		const select = document.querySelector('div.data-modal');
		const inputs = select.querySelectorAll('input, select, textarea');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);


		if(control !== null){
			if(control.value === ""){
				control.classList.add('error');
				res = false;
			}else{
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}

				res = true;
			}
		}

		return res;
	}

	addPhone({phone_number, phone_type}){
		var phones = this.state.follow.phones;

		if(phone_number !== "" && phone_type !== ""){
			phones.push({number:phone_number, type:phone_type});

			this.setState({
				follow:{
					...this.state.follow,
					phones:phones,
					phone_number:"",
					phone_type:""
				}
			});
		}
	}

	removePhone(i){
		var phones = this.state.follow.phones;

		phones.splice(i, 1);
		this.setState({
			follow:{
				...this.state.follow,
				phones:phones
			}
		});

	}

	render(){
		const { t } = this.props;
		
		return(
			<Modal show={this.state.show} onHide={this.handleClose}>
		        <Modal.Body >
			        <div className="row">
			        	{this.state.screen === 'seguimiento' ?
			        		<Following {...this.props} data={this.state.data} follow={this.state.follow}
			        			handleChange={this.handleChange}
			        			removePhone={this.removePhone}
			        			addPhone={this.addPhone} />
			        	:this.state.screen === 'medical' ?
			        		<Medical {...this.props} data={this.state.data} medical={this.state.medical}
			        		    title="Médico que realizo la entrevista: " name="medical" handleChange={this.handleChange} />
			        	: <Medical {...this.props} data={this.state.data} medical={this.state.personal} 
			        			title="Personal que elabora: " name="personal" handleChange={this.handleChange} />}

			        </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')}  onClick={this.onSave}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(GeneralModal) 